import { useCallback, useState } from 'react';
import { sendEmail } from '../services/emailService';

/**
 * Hook to centralize EmailJS contact message sending.
 * Provides a consistent interface around the emailService layer.
 */
export const useContactEmail = () => {
    const [isSending, setIsSending] = useState(false);
    const [lastError, setLastError] = useState(null);

    const sendContactMessage = useCallback(async (formElement) => {
        setIsSending(true);
        setLastError(null);

        try {
            return await sendEmail(formElement);
        } catch (error) {
            setLastError(error);
            throw error;
        } finally {
            setIsSending(false);
        }
    }, []);

    return {
        sendContactMessage,
        isSending,
        error: lastError,
    };
};
